module.exports = __webpack_public_path__ + "static/media/entregas_black.817bf468.png";